let elements = {
  mainImage: {
    imagePath: 'games/page997_game2/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  icons: {
    negative: 'games/page997_game2/img/t.png',
    positive: 'games/page997_game2/img/f.png',
  },
  withoutCheck: false,
  maxLength: 1,
  audio: {
    negative: 'games/page997_game2/audio/f.mp3',
    positive: 'games/page997_game2/audio/t.mp3',
  },
  pick: 10,
  questions: [
    {
      src: 'games/page997_game2/img/00.png',
      correct: 'A',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/01.png',
      correct: 'B',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/02.png',
      correct: 'C',
      width: 500,
    },
    // {
    //   src: 'games/page997_game2/img/03.png',
    //   correct: 'D',
    //   width: 500,
    // },
    {
      src: 'games/page997_game2/img/04.png',
      correct: 'D',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/05.png',
      correct: 'E',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/06.png',
      correct: 'F',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/07.png',
      correct: 'G',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/08.png',
      correct: 'H',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/09.png',
      correct: 'I',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/10.png',
      correct: 'J',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/11.png',
      correct: 'K',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/12.png',
      correct: 'L',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/13.png',
      correct: 'M',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/14.png',
      correct: 'N',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/15.png',
      correct: 'O',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/16.png',
      correct: 'P',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/17.png',
      correct: 'R',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/18.png',
      correct: 'S',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/19.png',
      correct: 'T',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/20.png',
      correct: 'U',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/21.png',
      correct: 'W',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/22.png',
      correct: 'Y',
      width: 500,
    },
    {
      src: 'games/page997_game2/img/23.png',
      correct: 'Z',
      width: 500,
    },
  ],
};

export default elements;
